import { WebviewLayout } from 'shared/layout/WebviewLayout';
import { CarrierOverviewPage } from 'shared/modules/carrier-profile/overview/CarrierOverviewPage';

export function CarrierRatingsScreenPage() {
  return (
    <WebviewLayout>
      <CarrierOverviewPage />
    </WebviewLayout>
  );
}
